import { observer } from 'mobx-react';

import {
  HeaderWrapper,
  HeaderTitle,
  LogoContainer,
  OfflineNotificationWrapper,
  OfflineIndicator,
} from 'containers/EntitiesFormPublicSubmission/styles';

import { useOnlineMonitor } from 'utils/hooks/useOnlineMonitor';
import { useOfflineReady } from 'hooks/useOfflineReady';
import { useStore } from 'utils/hooks/store';

import OfflineNotification from '../OfflineNotification';
import OfflineReady from '../OfflineReady/OfflineReady';
import logo from '../../../../assets/images/VatixLogoPublicSubmission.png';

const OfflineInfoHeader = ({ hideOfflineNotification }: { hideOfflineNotification?: boolean }): React.ReactElement => {
  const isOnline = useOnlineMonitor();
  const isOfflineReady = useOfflineReady();

  if (isOnline && isOfflineReady) {
    return (
      <OfflineNotificationWrapper>
        <OfflineReady />
      </OfflineNotificationWrapper>
    );
  }

  if (!isOnline && !hideOfflineNotification) {
    return (
      <OfflineNotificationWrapper>
        <OfflineNotification />
      </OfflineNotificationWrapper>
    );
  }

  return <></>;
};

const Header: React.FC<{
  formName?: string;
  hideOfflineNotification?: boolean;
}> = ({ formName, hideOfflineNotification }): React.ReactElement => {
  const {
    entitiesFormSubmission: { data },
  } = useStore();

  return (
    <>
      <LogoContainer>
        <img alt="Vatix logo" src={logo} />
        {/* Subtle green dot indicator when offline submission is enabled */}
        {data?.offlineSubmission && <OfflineIndicator title="Offline submissions are enabled" />}
      </LogoContainer>

      {data?.offlineSubmission && <OfflineInfoHeader hideOfflineNotification={hideOfflineNotification} />}

      {formName && (
        <HeaderWrapper>
          <HeaderTitle>{formName}</HeaderTitle>
        </HeaderWrapper>
      )}
    </>
  );
};

export default observer(Header);
